import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { AppBar } from "../common/utils";
import { useState } from "react";

import Img from '../../../assets/acg-logo.avif';

const DesktopHeader = ({ drawerOpen, openDrawer, logoutUser, headerData}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    navigate(`/Portal/Profile`);
    handleClose();
  };

  const handleLogout = () => {
    console.log("Log out");
    logoutUser();
    handleClose();
    navigate('/Company');
    
  };

  return (
    <AppBar position="fixed" open={drawerOpen}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={openDrawer}
          sx={{ mr: 5, ...(drawerOpen && { display: "none" }) }}
        >
          <MenuIcon />
        </IconButton>
          <Box sx={{width: 60}}>
            <img src={Img} alt='ACG' style={{ width:'100%', p:1}}/>
          </Box>
          <Typography variant="h6" noWrap component="div" sx={{p:2, flexGrow: 1 }}>
            Sales Tool
          </Typography>
        <Box>
          <Tooltip title="Account settings">
            <Button onClick={handleClick} size="small" sx={{ ml: 2 }}>
              <Avatar sx={{ width: 32, height: 32 }} src={headerData?.user?.icon}/>
              <Typography variant="subtitle1" noWrap component="div" sx={{ flexGrow: 1, p: 2, color: 'black' }}>
                {headerData?.user?.username}
              </Typography>
            </Button>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                mt: 1.5,
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={handleProfile}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default DesktopHeader;
